import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const useActiveArticleScroll = (
  activeRef: React.RefObject<HTMLDivElement>,
  scrollRef: React.RefObject<HTMLDivElement>,
) => {
  const location = useLocation();

  useEffect(() => {
    const activeElement = activeRef.current;
    const scrollContainer = scrollRef.current;
    if (!activeElement || !scrollContainer) return;

    if (scrollContainer.clientWidth < activeElement.offsetLeft + activeElement.clientWidth) {
      scrollContainer.scrollLeft = activeElement.offsetLeft;
    }
  }, [activeRef, scrollRef, location.pathname]);
};
